import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useMonthlyEvolutionHouseHoldVisit from './hooks/useMonthlyEvolutionHouseHoldVisit';

export const MonthlyEvolutionHouseHoldVisit = () => {
    const { chartConfig } = useMonthlyEvolutionHouseHoldVisit();

    return (
        <ChartContainer
            title={"Evolução do Total de visitas domiciliar no ano"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={350}
        />
    );
};
